import {Hydra} from '../generic/hydra';

import {CommissionSeanceParticipationInterface} from './CommissionSeanceParticipation';
import {CommissionSeance as CommissionSeanceBaseInterface} from '../../interface/api/CommissionSeance';

export type CommissionSeanceInterface = CommissionSeanceBaseInterface;

export class CommissionSeance extends Hydra implements CommissionSeanceInterface {

    id?: number | null;

    label?: string | null;

    commission?: any | null;

    /* Date et heure de début de séance. Garder l'heure !
     */
    datetimeDebut?: string | Date | null;

    /* Date et heure de fin de séance. Garder l'heure !
     */
    datetimeFin?: string | Date | null;

    aides?: any[] | null = [];

    commissionSeanceParticipations?: CommissionSeanceParticipationInterface[] | string[] | null = [];

    decisiveStatutDossier?: boolean = false;

    deletable?: boolean = false;


    constructor(options: CommissionSeanceInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
